"use client";

import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Banner } from "./banner";

const doctors = [
  {
    name: "PVC Stabilizers",
    specialty: "Lead, Tin & Calcium Zinc Stabilizers for various applications.",
    image: "/images/PVC_Stabilizers.jpg",
    bgColor: "bg-purple-50",
  },
  
  {
    name: "Calcium Carbonate",
    specialty: "Coated & Grounded Calcium Carbonate for plastic and other industries.",
    image: "/images/Calcium_Carbonate.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "PVC Resins",
    specialty: "Virgin and Reprocessed PVC Resins for manufacturing applications.",
    image: "/images/PVC_Resins.jpg",
    bgColor: "bg-purple-50",
  },
  
  {
    name: "Reprocessed PVC",
    specialty: "Shredded & Powder Reprocessed PVC for eco-friendly applications.",
    image: "/images/Reprocessed_PVC.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "HDPE (PE 100)",
    specialty: "High-Density Polyethylene (PE 100) for durable plastic products.",
    image: "/images/HDPE.jpg",
    bgColor: "bg-purple-50",
  },
  
  
  {
    name: "Reprocessed HDPE",
    specialty: "Reprocessed High-Density Polyethylene (PE 100) for reuse.",
    image: "/images/Reprocessed_HDPE.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "Impact Modifiers CPE",
    specialty: "Chlorinated Polyethylene (CPE) for improving impact strength.",
    image: "/images/Impact_Modifiers_CPE.webp",
    bgColor: "bg-purple-50",
  },
  
  {
    name: "PE Wax",
    specialty: "Polyethylene wax used for improving polymer properties.",
    image: "/images/PE_Wax.webp",
    bgColor: "bg-purple-50",
  },
  {
    name: "Epoxidized Soybean Oil",
    specialty: "Eco-friendly oil used in PVC stabilization.",
    image: "/images/Epoxidized_Soybean_Oil.jpg",
    bgColor: "bg-purple-50",
  },
  
  {
    name: "Titanium Dioxide",
    specialty: "White pigment used in various coatings and plastics.",
    image: "/images/Titanium_Dioxide.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "Carbon Black",
    specialty: "Pigment and reinforcement material used in rubber and plastics.",
    image: "/images/Carbon_Black.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "Calcium Oxide",
    specialty: "Used in various industrial processes like water treatment.",
    image: "/images/Calcium_Oxide.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "Antioxidants",
    specialty: "Prevent oxidation in plastics and polymers.",
    image: "/images/Antioxidants.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "Binders",
    specialty: "Essential components for paints and coatings applications.",
    image: "/images/Binders.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "Defoamers",
    specialty: "Chemicals used to reduce foam in industrial processes.",
    image: "/images/Defoamers.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "Dispersing Agents",
    specialty: "Help in evenly distributing pigments in paints and coatings.",
    image: "/images/Dispersing_Agents.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "Solvents",
    specialty: "Used to dissolve and thin paints, coatings, and adhesives.",
    image: "/images/Solvents.jpg",
    bgColor: "bg-purple-50",
  },
  {
    name: "PU Curing Agents",
    specialty: "Used for curing polyurethane-based coatings and foams.",
    image: "/images/PU_Curing_Agents.jpg",
    bgColor: "bg-pink-50",
  },
  {
    name: "Driers",
    specialty: "Speed up the drying process of coatings and paints.",
    image: "/images/Driers.webp",
    bgColor: "bg-blue-50",
  },
  {
    name: "Biocides",
    specialty: "Prevent microbial growth in various industries.",
    image: "/images/Biocides.jpg",
    bgColor: "bg-purple-50",
  },
];

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

export function ProductLists() {
  return (
    <>
     <Banner page={'Products'} heading={'All Products'} image={"/images/slider.jpg"}/>
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        {/* <div className="text-center mb-12 md:mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-blue-600 font-medium block mb-4"
          >
            Team Of Specialist
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold"
          >
            Meet Specialist Doctors
          </motion.h2>
        </div> */}

        <motion.div
  initial="hidden"
  whileInView="show"
  className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
>
  {doctors.map((doctor, index) => (
    <motion.div 
      key={index} 
      variants={item} 
      whileHover={{ scale: 1.05 }} 
      transition={{ duration: 0.3 }}
    >
      <div className="group relative overflow-hidden rounded-lg shadow-lg transition-transform duration-300 hover:shadow-xl">
        {/* Background Image */}
        <div
          className={`relative ${doctor.bgColor} aspect-[3/4] before:absolute before:inset-0 before:bg-[#030a5c84] before:opacity-75`}
        >
          <img
            src={doctor.image}
            alt={doctor.name}
            className="object-cover w-full h-full group-hover:scale-110 transition-transform duration-500"
          />
        </div>

        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-black/60 flex flex-col justify-end translate-y-full group-hover:translate-y-0 transition-transform duration-500">
          <div className="p-6 text-white">
            <p className="text-sm font-medium mb-1">{doctor.specialty}</p>
            <p className="text-xl font-bold mb-4">{doctor.name}</p>
            <button className="flex items-center space-x-2 text-white hover:text-blue-400 transition-colors">
              <span>View Profile</span>
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  ))}
</motion.div>

      </div>
    </section>
    </>
  );
}